import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toggleInfoModal, updateDictionaryDescription } from '../../../../actions/dictionary-values';
import { Button } from '../../../../components/button/button';
import Input from '../../../../components/input/input';
import { ModalComponent } from '../../../../components/Modal/modal';
import { ButtonVariant } from '../../../../core/enums';
import { styles } from './info-modal.styles';
export const InfoModal = (props)=>{
    const { selectedDictionary, viewOnly } = props;
    const dispatch = useDispatch();
    const [isEdit, updateIsEdit] = useState(false);
    const [description, updateDescription] = useState(selectedDictionary?.description ?? '');
    const [purpose, updatePurpose] = useState(selectedDictionary?.purpose ?? '');
    const _handleClose = ()=>{
        dispatch(toggleInfoModal(false));
    };
    const classes = styles();
    const handleSaveInfo = ()=>{
        const payload = {
            ...props.selectedDictionary,
            description: description.length === 0 ? props.selectedDictionary.description : description,
            purpose: purpose.length === 0 ? props.selectedDictionary.purpose : purpose
        };
        if (description.length === 0) {
            updateDescription(selectedDictionary.description);
        }
        if (purpose.length === 0) {
            updatePurpose(selectedDictionary.purpose);
        }
        dispatch(updateDictionaryDescription(payload));
        updateIsEdit(false);
    };
    return isEdit ? /*#__PURE__*/ _jsx(ModalComponent, {
        size: 'xl',
        showCloseIcon: true,
        isOpen: true,
        handleClose: _handleClose,
        modalHeader: /*#__PURE__*/ _jsx("div", {
            "data-testid": "modal-header",
            children: "Dictionary Info"
        }),
        modalContent: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: 'column',
            rowGap: 5,
            sx: classes.editMode,
            children: [
                /*#__PURE__*/ _jsx(Input, {
                    label: "Description:",
                    isDisabled: viewOnly,
                    onChange: (e)=>{
                        updateDescription(e.target.value);
                    },
                    name: 'Description',
                    placeholder: 'Description',
                    value: description ?? ''
                }),
                /*#__PURE__*/ _jsx(Input, {
                    label: "Purpose:",
                    isDisabled: viewOnly,
                    onChange: (e)=>updatePurpose(e.target.value),
                    name: 'Purpose',
                    placeholder: 'Purpose',
                    value: purpose ?? ''
                })
            ]
        }),
        modalFooter: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: 'row',
            columnGap: 3,
            sx: classes.footer,
            children: [
                /*#__PURE__*/ _jsx(Flex, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        label: 'Cancel',
                        onClick: _handleClose,
                        variant: ButtonVariant.SECONDARY
                    })
                }),
                /*#__PURE__*/ _jsx(Flex, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        label: 'Save',
                        disabled: viewOnly,
                        onClick: handleSaveInfo
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ _jsx(ModalComponent, {
        size: 'xl',
        showCloseIcon: true,
        isOpen: true,
        handleClose: _handleClose,
        modalHeader: /*#__PURE__*/ _jsx("div", {
            children: "Dictionary Info"
        }),
        modalContent: /*#__PURE__*/ _jsxs("div", {
            style: classes.viewMode,
            children: [
                /*#__PURE__*/ _jsx("h5", {
                    children: "Description:"
                }),
                /*#__PURE__*/ _jsx("p", {
                    children: description
                }),
                /*#__PURE__*/ _jsxs("div", {
                    style: classes.contentSpacing,
                    children: [
                        /*#__PURE__*/ _jsx("h5", {
                            children: "Purpose:"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: purpose
                        })
                    ]
                })
            ]
        }),
        modalFooter: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: 'row',
            columnGap: 3,
            sx: classes.footer,
            children: [
                /*#__PURE__*/ _jsx(Flex, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        label: 'Cancel',
                        onClick: _handleClose,
                        variant: ButtonVariant.SECONDARY
                    })
                }),
                /*#__PURE__*/ _jsx(Flex, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        label: 'Edit',
                        disabled: viewOnly,
                        onClick: ()=>updateIsEdit(true)
                    })
                })
            ]
        })
    });
};
